import React from 'react';
import Styled, { css } from 'styled-components';
import { device,breakpoints } from '../../../utils/responsive_utilities';
import { styledFont } from '../../../../../landing-pages/js/common/mixins/mixin';
import Image from '../../../components/loggedout/common/Image';
import Expand from '~images/tutoring-pitch/expand-accordion.svg';
import Collapse from '~images/tutoring-pitch/collapse-accordion.svg';
import { blackLight } from '../../../components/loggedout/shared-styles/Colors';


const Accordion = ({
  question,
  answer,
  openState,
  setAccData,
  index,
  accData,
  isTutoring,
  changeImageWidth
}) => {
  const toggle = (idx) => {
    let data = [...accData];
    data[idx].openState = !data[idx].openState;
    for(let i=0; i<data.length; ++i)
    {
      if(i!=idx)
      data[i].openState=false;
    }
    setAccData(data);
  };

  return (
    <AccordionItem>
      <AccordionTitle onClick={() => toggle(index)}>
        {openState ? (
          <MinusImage changeWidth = {changeImageWidth}>
            <Image alt="image" src={Collapse} />
          </MinusImage>
        ) : (
          <PlusImage changeWidth = {changeImageWidth}>
            <Image alt="image" src={Expand} />
          </PlusImage>
        )}
        <Question changeMargin={changeImageWidth}>{question}</Question>
      </AccordionTitle>
      {openState && <Answer isTutoring={isTutoring}>{answer}</Answer>}
      <HorizontalLine></HorizontalLine>
    </AccordionItem>
  );
};

export default Accordion;

export const AccordionItem = Styled.div`
  margin-top: 1.6rem;
`;

export const AccordionTitle = Styled.div`
  display: flex;
  align-items: baseline;
`;

export const Question = Styled.div`
${props => props.changeMargin ? "margin-left: 1rem":"margin-left: 2rem"};
  
  display: inline-block;
  letter-spacing: 0.32px;
  color: ${blackLight};
  ${styledFont('Graphie', 1.8, 2.4, 6)}
  @media (min-width: ${breakpoints.md}px) {
    ${styledFont('Graphie', 2, 2.8, 6)}
  }
`;

export const Answer = Styled.p`
  margin-top: 1.2rem;
  margin-left: 3.6rem;
  letter-spacing: 0.32px;
  color: ${blackLight};
  ${props => props.isTutoring ? 
    css`
      ${styledFont('Graphie', 1.6, 2.2, 5)}
    `: 
    css`
      ${styledFont('Graphie', 1.6, 2.2, 6)}
    ` 
  };
`;

export const MinusImage = Styled.div`
  width: 1.6rem;
  height: 1.6rem;
  ${props => props.changeWidth && css`flex:0 0 5%`};
`;

export const PlusImage = Styled.div`
  width: 1.6rem;
  height: 1.6rem;
  ${props => props.changeWidth && css`flex:0 0 5%`};
`;

export const HorizontalLine = Styled.hr`
  margin-top: 1.6rem;
  margin-left: 3.6rem;
`;
